module.exports = __webpack_public_path__ + "img/stripe.2da64a0.png";